const routes_without_container_spaces = [
    "/merchant/zones"
]

export const containerSpacing = (current_route)=>{
    console.log("current_route", current_route)
    if (routes_without_container_spaces.includes(current_route)) {
        return false
    } else {
        return true
    }
}